import { render } from "./ServiceCallDetail.vue?vue&type=template&id=14dd79e3"
import script from "./ServiceCallDetail.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ServiceCallDetail.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script